import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { config } from "../../constants";
import { fetchBanners } from "../../store/banners/bannersAction";

class banner extends Component {
  componentDidMount() {
    // this.props.fetchBanners(this.props);
  }
  openUrlLink = (url_link) => {
    if (url_link) {
      window.open(url_link, '_blank');
    }
  }
  render() {
    return (
      <div className="container">
        <div id="myCarousel" className="carousel slide" data-ride="carousel">
          <ol className="carousel-indicators">
            {this.props.banners.map((banner, index) => (
              <li
                key={index}
                data-target="#myCarousel"
                data-slide-to={index}
                className={index === 0 ? "active" : ""}
              />
            ))}
          </ol>
          <div className="carousel-inner">
            {this.props.banners.map((banners, index) => (
              <div
                key={index}
                className={"carousel-item " + (index === 0 ? "active" : "")}
              >
                <img
                  src={((banners.bucket_type.toLowerCase()==='mno')?config.mediaPath +'banners/'+ banners.image_name:config.imagePath + banners.image_name)} alt={banners.image_name}
                  onClick={e => this.openUrlLink(banners.url_link)} 
                  style={banners.url_link ? {cursor: "pointer"}:{}}
                  />
              </div>
            ))}
          </div>
          <a
            className="carousel-control-prev"
            href="#myCarousel"
            role="button"
            data-slide="prev"
          >
            <span className="la la-angle-left" aria-hidden="true" />
            <span className="sr-only">Previous</span>
          </a>
          <a
            className="carousel-control-next"
            href="#myCarousel"
            role="button"
            data-slide="next"
          >
            <span className="la la-angle-right" aria-hidden="true" />
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  banners: state.banners.items,
  project_id: state.project.info.project_id,
  project: state.project.info
});
banner.propTypes = {
  fetchBanners: PropTypes.func.isRequired
};
export default connect(
  mapStateToProps,
  { fetchBanners }
)(banner);
